import React from "react";
import { Text, View, ActivityIndicator, SafeAreaView } from "react-native";

import { isAppleDevice } from "../../../../helpers/utils";
import Icons from "../../common/icons";
import ExportIcon from "../../common/ExportIcon";
import StarRating from "../../common/StarRating/StarRating";

import ExitTutorialsButton from "../../common/header/ExitTutorialsButton";
import AppTheme from "../../AppTheme";
import headerStyles from "../../common/header/headerStyles";

export default function ReflectionEditHeader(props) {
  const {
    controller,
    isLoading,
    reflection: { edit_name, goal },
    onGoBack = () => {},
    highlightBack = false,
    createNewReport,
  } = props;

  const title = edit_name ? "Element Details" : "Details";

  return (
    <SafeAreaView
      style={[headerStyles.container, isAppleDevice && { paddingTop: 20 }]}
    >
      <View
        style={[
          headerStyles.header,
          {
            minHeight: 60,
            justifyContent: "center",
          },
        ]}
      >
        <View style={headerStyles.leftContainer}>
          <Icons.Back
            onPress={() => onGoBack(highlightBack)}
            highlight={highlightBack}
          />
        </View>

        {/* Exit tutorials */}
        <ExitTutorialsButton controller={controller} />

        <View style={headerStyles.titleContainer}>
          <Text style={headerStyles.title}>{title}</Text>
        </View>

        <View style={headerStyles.rightContainer}>
          {createNewReport ? 
            <ExportIcon
              onPress={createNewReport}
              width={20}
              height={20}
            />
          : null }

          {goal ? <StarRating rating={goal.importance} starSize={12} /> : null}

          {isLoading ? (
            <ActivityIndicator
              size="large"
              color={AppTheme.lightGray}
              style={headerStyles.loading}
            />
          ) : null}
        </View>
      </View>
    </SafeAreaView>
  );
}
